import { getSyncHeaders } from './utils';
import { getSyncHost } from '../utils/hosts';
import logger from '../utils/logger-rum';

export const getCommToggle = async (
	meeting: number,
	token: string,
) => {
	try {
		const response = await fetch(
			`${getSyncHost()}/v1/comms-toggle/${meeting}`,
			{
				method: 'GET',
				headers: getSyncHeaders(token),
			},
		);
		if (response.ok) {
			return await response.json();
		}
		logger.error('Unable to get comms toggle.');
	} catch (error) {
		logger.error(error);
	}

	return { version: 0, entityValues: [] };
};

export const setCommToggle = async (
	meeting: number,
	token: string,
	producer: number,
	presenter: string,
	allOnCanvas: boolean = false,
) => {
	try {
		const response = await fetch(
			`${getSyncHost()}/v1/comms-toggle/${meeting}`,
			{
				method: 'POST',
				headers: getSyncHeaders(token),
				body: JSON.stringify({
					producer,
					presenter,
					allOnCanvas,
				}),
			},
		);

		if (response.ok) {
			return await response.json();
		}
		logger.error('Unable to get comms toggle.');
	} catch (error) {
		logger.error(error);
	}

	return { version: 0, entityValues: [] };
};

export const deleteCommToggle = async (
	meeting: number,
	token: string,
	producer: number,
) => {
	try {
		const response = await fetch(
			`${getSyncHost()}/v1/comms-toggle/${meeting}`,
			{
				method: 'DELETE',
				headers: getSyncHeaders(token),
				body: JSON.stringify({
					producer,
				}),
			},
		);

		if (response.ok) {
			return await response.json();
		}
		logger.error('Unable to get comms toggle.');
	} catch (error) {
		logger.error(error);
	}

	return { version: 0, entityValues: [] };
};
